module.exports = __webpack_public_path__ + "static/busra-pinduk-fd50acaa15724abed55c0a5f02ebe878.webp";